export const navbarEn = {
    aboutUs: "About us",
    ourTeam: "Our team",
    contactUs: "Contact us",
    latestPosts: "Latest posts",
    linguisticExpertise: "Linguistic expertise",
    translationsServices: "Translation services",
    ourServices: "Our services",
    phonoscopy: "Phonoscopy",
    educationalCourses: "Educational courses"
};
